const pluralizeString = (amount: number, word: string, suffix = "s") => {
	return `${amount} ${word}${amount !== 1 ? suffix : ''}`
}

export default pluralizeString